document.addEventListener("DOMContentLoaded", (event) => {
  const swatchItems = document.querySelectorAll('.sibling-swatch');
  swatchItems.forEach((swatch) => {
    swatch.addEventListener('mouseover', (event) => {
      const secondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.mainProductId}'] [data-sibling-id='${event.currentTarget.dataset.swatchId}']`);
      secondaryImage.style.visibility = 'visible';
      secondaryImage.classList.add('sm:transition-transform', 'sm:duration-300', 'sm:group-hover:scale-[103%]')
      const primaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.mainProductId}'] .product-card__featured-image`)
      primaryImage.style.visibility = 'hidden';
    })
   swatch.addEventListener('mouseout', (event) => {
      const allSecondaryImage = document.querySelectorAll(`[data-product-card='${event.currentTarget.dataset.mainProductId}'] .product-card__secondary-image:not([data-sibling-id='${event.currentTarget.dataset.swatchId}'])`)
      allSecondaryImage.forEach((secondImg) => {
        secondImg.style.visibility = 'hidden';
      })
    })

    // if(window.innerWidth < 768) {
    //   const whatDevice2 = /iPad|iPhone|iPod/.test(navigator.userAgent);
    //   let whatEventUse2 = whatDevice2 ? 'touchstart' : 'click';
      
    //   swatch.addEventListener(whatEventUse2, (event) => {
    //     var closestParent = event.currentTarget.parentNode.closest('.product-card');
    //     var allSecondImages=closestParent.querySelectorAll('.product-card__secondary-image')
    //     if(allSecondImages && allSecondImages > 0) {
    //       allSecondImages.forEach((el) => {
    //         secondaryImage.style.visibility = 'hidden';
    //         secondaryImage.classList.remove('sm:transition-transform', 'sm:duration-300', 'sm:group-hover:scale-[103%]')
    //       })
    //     }
        
    //     const secondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.mainProductId}'] [data-sibling-id='${event.currentTarget.dataset.swatchId}']`);
    //     secondaryImage.style.visibility = 'visible';
    //     secondaryImage.classList.add('sm:transition-transform', 'sm:duration-300', 'sm:group-hover:scale-[103%]')
    //     secondaryImage.style.zIndex = 11;
    //   })
    // }
  })

  const primarySwatches = document.querySelectorAll('.primary-swatch');
  primarySwatches.forEach((swatch) => {
    swatch.addEventListener('mouseover', (event) => {
      const siblingSecondaryImages = document.querySelectorAll(`[data-product-card='${event.currentTarget.dataset.swatchId}'] [data-sibling-id]`);
      siblingSecondaryImages.forEach((secondImg) => {
        secondImg.style.visibility = 'hidden';
      })
      const primaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.swatchId}'] .product-card__featured-image`);
      const primarySecondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.swatchId}'] .product-card__secondary-image`);
      primaryImage.style.visibility = 'visible';
      primarySecondaryImage.style.visibility = 'visible';
    })
  })
});



